import { Button, Dropdown } from "antd";
import React, { useState } from "react";
import { GoPlusCircle } from "react-icons/go";
import { IoFilterCircleOutline } from "react-icons/io5";
import { PiHamburger } from "react-icons/pi";
import { Link, useNavigate } from "react-router-dom";
import { IoDocumentTextOutline } from "react-icons/io5";
import { IoMdPerson } from "react-icons/io";
import { MdOutlineIncompleteCircle } from "react-icons/md";
import { MdOutlineCalculate } from "react-icons/md";
import Total from "../../Pages/YukXati/Total/Total";
import { GrHomeRounded } from "react-icons/gr";
import { TbSmartHome } from "react-icons/tb";

export default function YukXatiHeader({ PageTitle }) {
  let navigate = useNavigate();
  let [open, setOpen] = useState(null);

  const items = [
    {
      key: "1",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati"
        >
          <IoDocumentTextOutline className="font-[30px]" /> Yuk xatlari
        </Link>
      ),
    },

    {
      key: "3",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/customers"
        >
          <IoMdPerson /> Xaridorlar
        </Link>
      ),
    },
    {
      key: "4",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati/kirim"
        >
          <MdOutlineIncompleteCircle /> Kirimlar
        </Link>
      ),
    },
    {
      key: "5",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/yukxati/kirim/new"
        >
          <GoPlusCircle className="font-[30px]" /> kirim qo'shish
        </Link>
      ),
    },

    {
      key: "7",
      label: (
        <div
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          // to="/yukxati/total"
          onClick={() => {
            setOpen(true);
          }}
        >
          <MdOutlineCalculate className="font-[30px]" /> Jami
        </div>
      ),
    },
    {
      key: "9",
      label: (
        <Link
          className=" block w-[100%] flex items-center justify-start gap-1"
          rel="noopener noreferrer"
          to="/"
        >
          <TbSmartHome className="font-[30px]" /> Bosh sahifa
        </Link>
      ),
    },
  ];

  return (
    <div className="max-w-[900px] m-auto w-[100%] flex  bg-[#fff] z-10 flex-row  items-center justify-between p-[10px]">
      <h2 className="bold text-[20px]">{PageTitle}</h2>
      <Total setOpen={setOpen} open={open} />
      <div className="flex gap-1">
        <Dropdown
          menu={{
            items,
          }}
          placement="topRight"
          arrow
        >
          <Button>
            <PiHamburger />
          </Button>
        </Dropdown>
      </div>
    </div>
  );
}
